import React from 'react'
import { observer } from '~/ui/component'
import { HBox, Label, Scroller, SwitchField, VBox } from '~/ui/components'
import { FormField, useForm } from '~/ui/form'
import { layout } from '~/ui/styling'
import { CustomImageField, RichTextField } from '../../fields'
import ProjectSettingsFormModel from './ProjectSettingsFormModel'
import { useResourceTranslation } from '~/ui/resources'
import HomeScreenWidgets from './home-screen-widgets/HomeScreenWidgets'

export interface Props {

}

const HomeScreenSettings = observer('HomeScreenSettings', (props: Props) => {

  const {model: formModel, submit} = useForm<ProjectSettingsFormModel>()

  const {t} = useResourceTranslation('projects')

  //------
  // Rendering

  function render() {
    return (
      <Scroller contentPadding={layout.padding.m}>
        <HBox align='stretch' flex gap={layout.padding.l}>
          <VBox flex gap={layout.padding.s}>
            <Label h3>{t('home-screen.hero')}</Label>
            {renderHeroFields()}
          </VBox>
          <VBox flex gap={layout.padding.s}>
            <Label h3>{t('home-screen.widgets.caption')}</Label>
            {renderWidgets()}
          </VBox>
        </HBox>
      </Scroller>
    )
  }

  function renderHeroFields() {
    return (
      <VBox flex gap={layout.padding.xs} align='stretch'>
        <HBox align='top' gap={layout.padding.s}>
          <FormField flex='grow' name='homeScreen.hero.background.image'>
            {bind => <CustomImageField {...bind} />}
          </FormField>
          <FormField name='homeScreen.hero.search'>
            {bind => <SwitchField {...bind} />}
          </FormField>
        </HBox>
        <FormField name='homeScreen.hero.background.darken'>
            {bind => <SwitchField {...bind} />}
          </FormField>
          <FormField name='homeScreen.hero.background.fade'>
            {bind => <SwitchField {...bind} />}
          </FormField>
        <FormField name='homeScreen.hero.welcomeMessage'>
          {bind => (
            <RichTextField
              allowedNodes={['em', 'strong', 'variable']}
              localized
              commitOnBlur
              onCommit={() => submit()}
              {...bind}
              value={formModel.getValue('homeScreen.hero.welcomeMessage') ?? {}}
            />
          )}
        </FormField>
      </VBox>
    )
  }

  function renderWidgets() {
    return (
      <VBox flex>
        <HomeScreenWidgets/>
      </VBox>
    )
  }

  return render()

})

export default HomeScreenSettings